// extracted by mini-css-extract-plugin
export default {"root":"EmojiPicker_root__m5Q2U","rootShow":"EmojiPicker_rootShow__heAn6"};